(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5973],{

/***/ 58634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ wbso_application_intro; }
});

// EXTERNAL MODULE: ./src/components/layouts/ApplicationLayout.js
var ApplicationLayout = __webpack_require__(62159);
// EXTERNAL MODULE: ./src/data/wbsoApp/useWbsoQuestions.js
var useWbsoQuestions = __webpack_require__(47089);
// EXTERNAL MODULE: ./src/views/WBSOApplicationForm/components/ApplicationForm.js + 5 modules
var ApplicationForm = __webpack_require__(17301);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/WBSOApplicationForm/WBSOAppFormView.js





var WBSOAppFormView = function WBSOAppFormView() {
  var _useWbsoQuestions = (0,useWbsoQuestions/* default */.Z)(),
      questions = _useWbsoQuestions.data,
      loadingQuestions = _useWbsoQuestions.isLoading;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ApplicationLayout/* default */.Z, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ApplicationForm/* default */.Z, {
      withIntro: true,
      loading: loadingQuestions,
      questions: questions
    })
  });
};

/* harmony default export */ var WBSOApplicationForm_WBSOAppFormView = (WBSOAppFormView);
;// CONCATENATED MODULE: ./src/pages/wbso-application-intro.js



var IntroPage = function IntroPage(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(WBSOApplicationForm_WBSOAppFormView, {});
};

var __N_SSP = true;
/* harmony default export */ var wbso_application_intro = (IntroPage);

/***/ }),

/***/ 78324:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wbso-application-intro",
      function () {
        return __webpack_require__(58634);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1522,5932,1147,536,2676,8883,9774,2888,179], function() { return __webpack_exec__(78324); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);